import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles, Typography, TextField, Dialog, DialogTitle, DialogContent, DialogActions} from "@material-ui/core";
import CancelAcceptForm from "../Common/CancelAcceptForm";
import {themeTypeToBool} from '../../utils/helpers';
import t from "../../languages/pl";
import EmailTextField from './../Common/InputFields/EmailTextField';
import InformationDialog from '../Common/InformationDialog';

const useStyles = theme => ({
    container: {
        margin: theme.spacing(1),
        marginBottom: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    dialogActions: {
        margin: theme.spacing(1)
    },
    inputField: {
        minWidth: 250,
        margin: theme.spacing(1)
    }
});

const ForgotPassword = props => {
    const {classes, theme, onForgotPassword} = props;
    const [open, setOpen] = useState(false);
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [confirmOpen, setConfirmOpen] = useState(false);

    const handleSubmit = () => {
        onForgotPassword && onForgotPassword(username, email);
        setConfirmOpen(true);
    };

    const closeDialogs = () => {
        setConfirmOpen(false);
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Typography
                variant="body1"
                style={{cursor: "pointer"}}
                onClick={() => setOpen(true)}
            >
                {t.forgotPassword}
            </Typography>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="sm"
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    {t.forgotPassword}
                </DialogTitle>
                <DialogContent>
                    <form className={classes.container}>
                        <TextField
                            classes={{root: classes.inputField}}
                            label={t.usernameLabel}
                            type="text"
                            name="username"
                            value={username}
                            color={themeTypeToBool(theme.palette.type) ? "secondary" : "primary"}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <EmailTextField
                            className={classes.inputField}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </form>
                    <InformationDialog
                        open={confirmOpen}
                        onClose={closeDialogs}
                        title={t.confirmation}
                        content={t.forgotPasswordConfirmation}
                    />
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <CancelAcceptForm
                        onCancel={() => setOpen(false)}
                        onSubmit={handleSubmit}
                    />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

ForgotPassword.propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
    onForgotPassword: PropTypes.func
};

export default withStyles(useStyles, {withTheme: true})(ForgotPassword);
